import type { EnrichmentStats } from './stats.domain';

type Totals = EnrichmentStats['totals'];

/** MUI palette keys a KPI can map to (the UI resolves these to colors/icons). */
export type KpiPalette = 'info' | 'warning' | 'success' | 'error' | 'primary';

export interface Kpi {
  key: string;
  label: string;
  value: string | number;
  paletteKey: KpiPalette;
}

/** Compact, locale-free number abbreviation: 1234 → "1.2K", 2_500_000 → "2.5M". */
export function formatLargeNumber(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return n.toLocaleString();
}

/**
 * Derives the five KPI tiles shown above the sessions table: the total first,
 * like Users and Licences (#612), then one per status. Each is a scope of the
 * table. The profile figures (enriched, error rate) were dropped at #612: they
 * count profiles, which no row of this table lists; Metrics carries them.
 * Pure: returns plain data (label/value/paletteKey); icons and colors are
 * resolved in the UI layer.
 */
export function buildKpis(totals: Totals): Kpi[] {
  return [
    { key: 'sessions', label: 'Sessions', value: totals.total_sessions, paletteKey: 'primary' },
    { key: 'active', label: 'Active', value: totals.active, paletteKey: 'info' },
    { key: 'paused', label: 'Paused', value: totals.paused, paletteKey: 'warning' },
    { key: 'completed', label: 'Completed', value: totals.completed, paletteKey: 'success' },
    { key: 'failed', label: 'Failed', value: totals.failed, paletteKey: 'error' },
  ];
}
